import { createSelector } from 'reselect'
import { fromJS } from 'immutable'

const getApp = state => state.app

const getHero = state => state.hero

const getPageHome = state => state.page_home

export const getHeroFetching = createSelector(
  [getHero],
  hero => hero.get('fetching')
)

export const getHeroInViewport = createSelector(
  [getApp, getPageHome],
  (app, pageHome) => {
    const st = pageHome.get('st')
    const ph = pageHome.get('ph')
    const vh = app.get('vh')

    if (st === 0) return true
    if (vh === 0) return true
    if (ph === 0) return true

    const inViewport = st < vh || st > (ph -vh)
    
    return inViewport
  }
)

// const toLowerCase = str => str.replace(/\s+/g, '-').toLowerCase();

const getFeaturedMedia = slide => {
  const embedded = slide.get('_embedded')
  return (embedded && embedded.get('wp:featuredmedia')) ? embedded.get('wp:featuredmedia').first().get('source_url') : ''  
}

const getHeroMedia = slide => {
  const acf = slide.get('acf')
  
  if (!acf) { return false }
  
  const heroType = acf.get('hero_media_type') || 'image'
  let heroMedia
  
  if ( heroType === 'video' ) {
    
    heroMedia = (acf && acf.get('hero_media_video'))
    
    return fromJS([{
      type: 'video',
      hero_video: acf.get('hero_media_video')
    }])
    
  } else {
    
    heroMedia = (acf && acf.get('hero_media_image')) ? acf.get('hero_media_image') : null
    
    // Check hero_image has a url set, if not return false
    if (!heroMedia || !heroMedia.first()) { return false }

    if (!heroMedia.first().get('hero_image')) {
      return fromJS([{
        type: 'image',
        hero_image: getFeaturedMedia(slide),
      }])
    }
  }

  return heroMedia
}

const getDisciplineLabel = (artist, disciplineId) => {
  const embedded = artist.get('_embedded')
  if (embedded) {
    return embedded.get('wp:term').first().find(o => {
      return o.get('id') === disciplineId
    }).get('name')
  }
  return null
}

const getSlide = slide => {
  const acf = slide.get('acf')
  const isArtist = slide.get('type') === 'artists'
  const discipline = isArtist && slide.get('discipline') ? getDisciplineLabel(slide, slide.get('discipline').first()) : ''
  const artistName = (acf && acf.get('artist_name')) ? acf.get('artist_name').get('post_title') : ''
  const postTitle = slide.get('title').get('rendered')
  const title = isArtist ? postTitle : artistName
  const subtitle = isArtist ? discipline : postTitle

  return {
    id: slide.get('id'),
    title: title,
    subtitle: subtitle,
    media: getHeroMedia(slide)
  }
}
export const getSlides = createSelector(
  [getHero],
  hero => {
    const data = hero.get('hero')

    if (data && data.get && data.get('collections')) {
      const slides = data.get('collections')
      return slides && slides.map(getSlide)
    }
    
    return null
  }
)



// WEBPACK FOOTER //
// ./src/components/hero/selectors.js